
import { KTProject, KTTask } from '../types/kt-types.ts';

const STORAGE_KEY = 'kt_projects';
const TASKS_STORAGE_KEY = 'kt_tasks';

export const saveProjectsToLocalStorage = (projects: KTProject[]) => {
  try {
    const serializableProjects = projects.map(project => ({
      ...project,
      uploadedDocuments: project.uploadedDocuments?.map(file => ({
        name: file.name,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified
      })) || []
    }));
    localStorage.setItem(STORAGE_KEY, JSON.stringify(serializableProjects));
    console.log('Projects saved to localStorage:', serializableProjects);
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const saveTasksToLocalStorage = (tasks: KTTask[]) => {
  try {
    localStorage.setItem(TASKS_STORAGE_KEY, JSON.stringify(tasks));
    console.log('Tasks saved to localStorage:', tasks);
  } catch (error) {
    console.error('Error saving tasks to localStorage:', error);
  }
};

export const loadProjectsFromLocalStorage = (): KTProject[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const projects = JSON.parse(stored);
      console.log('Projects loaded from localStorage:', projects);
      return projects;
    }
  } catch (error) {
    console.error('Error loading from localStorage:', error);
  }
  
  return [
    {
      id: '1',
      projectName: 'Financial Analysis KT - Q1 2024',
      role: 'Senior Financial Analyst',
      department: 'Finance',
      startDate: '2024-01-15',
      endDate: '2024-02-15',
      status: 'active',
      progress: 65,
      description: 'Knowledge transfer for monthly financial reporting and budget analysis processes',
      manager: 'John Smith'
    },
    {
      id: '2',
      projectName: 'Team Leadership Transition',
      role: 'Team Lead - Finance Operations',
      department: 'Finance',
      startDate: '2024-01-20',
      endDate: '2024-02-15',
      status: 'pending',
      progress: 0,
      description: 'Transition of team management responsibilities and ongoing projects',
      manager: 'Sarah Wilson'
    }
  ];
};

export const loadTasksFromLocalStorage = (): KTTask[] => {
  try {
    const stored = localStorage.getItem(TASKS_STORAGE_KEY);
    if (stored) {
      const tasks = JSON.parse(stored);
      console.log('Tasks loaded from localStorage:', tasks);
      return tasks;
    }
  } catch (error) {
    console.error('Error loading tasks from localStorage:', error);
  }
  
  return [
    {
      id: '1',
      ktId: 'kt-001',
      role: 'Senior Financial Analyst',
      department: 'Finance',
      lastDay: '2024-02-15',
      status: 'in-progress',
      daysRemaining: 12
    },
    {
      id: '2',
      ktId: 'kt-002',
      role: 'Team Lead - Finance Operations',
      department: 'Finance',
      lastDay: '2024-02-15',
      status: 'pending',
      daysRemaining: 12
    }
  ];
};

export const clearAllLocalStorage = () => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(TASKS_STORAGE_KEY);
  console.log('localStorage cleared');
};